<template>
	<div class="articalDetail">
		<div class="title">
			<h4>{{ newsDetail.title }}</h4>
			<p>发表时间：{{ newsDetail.timeConf ? parseTime(newsDetail.timeConf) : parseTime(newsDetail.createTime) }}</p>
		</div>
		<div class="content ql-editor" v-html="newsDetail.textDescription"></div>
	</div>
</template>

<script setup>
	import { getPartDetail } from '@/api/index'
	import { ref, onMounted, getCurrentInstance } from 'vue'
	import { useRoute } from 'vue-router'
	
	const { proxy } = getCurrentInstance(); 
	const router = useRoute();
	const newsDetail = ref({})//大事件4
	onMounted(()=>{
		getPartDetail({ ifPage: 0, id: router.params.Id }).then((res)=>{
			if(res.total > 0){
				newsDetail.value = res.rows[0];
			}
		})
	})
	
</script>
<style lang="less">
  @import '@/assets/css/common';
</style>
<style lang="less" scoped>
.articalDetail{
	max-width: 1200px;margin: 0 auto;
	.title{
		text-align: center;margin: 20px;
		h4{
			font-size: 28px;color: #ff5a00;margin-bottom: 10px;
		}
		p{
			font-size: 14px;color: #999;
		}
	}
	.content{
		padding: 10px;box-sizing: border-box;
		/deep/ img{
			max-width: 100%;margin: 10px auto;
		}
	}
}
</style>
